import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ApiHandlerService } from '../../shared/services/api-handler.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { API } from "src/app/shared/services/endpoints";
import { DatePipe } from '@angular/common';
import { CustomPhonePipe } from 'src/app/shared/pipes/custom-data-filters.pipe';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-career-detail',
  templateUrl: './career-detail.component.html',
  styleUrls: ['./career-detail.component.scss']
})
export class CareerDetailComponent implements OnInit {
  gender_Id = 1;
  todayDate: any
  applyJobForm: FormGroup;
  public submitted: boolean = false;
  isLoadingData = false;
  id;
  currentOpening
  @ViewChild(FormGroupDirective) contactFormGroupDirective: FormGroupDirective;

  constructor(
    public formBuilder: FormBuilder,
    public _service: ApiHandlerService,
    private modalService: NgbModal,
    public datePipe: DatePipe,
    private _router: Router,
    private _route: ActivatedRoute,
    public customPhone: CustomPhonePipe,
    public toaster: ToasterService) {
    this.todayDate = new Date();
    this.todayDate.setDate(this.todayDate.getDate() - 5841);
    this.todayDate = this.datePipe.transform(this.todayDate, "yyyy-MM-dd");
  }

  genderSwitch(id) {
    this.gender_Id = id;
  }

  ngOnInit(): void {
    this.applyJobForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', Validators.required],
      info: ['', Validators.required],
      dob: ['', Validators.required],
      education: ['', Validators.required],
      workingIn: ['', Validators.required],
      resume: ['', Validators.required],
    })
    this.id = this._route.snapshot.params.id;
    this.id && this.getJobById()
    let footer = document.getElementsByTagName('footer');
    footer[0].classList.add('without-cars');
    if (footer[1]) {
      footer[1].classList.add('without-cars');
    }
  }
  get f() { return this.applyJobForm.controls; }

  ngOnDestroy() {
    let footer = document.getElementsByTagName('footer')[0];
    footer.classList.remove('without-cars');
  }

  getJobById() {
    const url = API.CMS_ENDPOINTS.GET_JOB(this.id)
    this._service.apiGet(url).subscribe({
      next: next => {
        console.log(next)
        this.currentOpening = next.data
      },
      error: err => {
        console.log(err)
      },
      complete: () => {

      }
    })
  }
  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  onSelect(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.applyJobForm.patchValue({ resume: file });
    this.applyJobForm.get('resume').updateValueAndValidity();
  };

  submitApplyJobForm(data) {
    this.submitted = true;
    if (this.applyJobForm.invalid) return;
    this.isLoadingData = true;
    var apiData = {
      name: this.applyJobForm.value.name,
      mobile: this.customPhone.transform(this.applyJobForm.value.mobile, ''),
      education: this.applyJobForm.value.education,
      resume: this.applyJobForm.value.resume,
      email: this.applyJobForm.value.email,
      workingIn: this.applyJobForm.value.workingIn,
      jobApplicationId: this.id,
      gender: this.gender_Id == 1 ? "M" : "F",
      dob: this.datePipe.transform(this.applyJobForm.value.dob, 'MM/dd/yyyy'),
      info: this.applyJobForm.value.info
    };
    const formData = new FormData();
    for (const k in apiData) {
      if (Object.prototype.hasOwnProperty.call(apiData, k)) {
        formData.append(k, apiData[k])
      }
    }
    this._service
      .apiPost(API.ADMIN_USER_ENDPOINTS.APPLY_JOBS, formData, {}, { contentType: { isFormDataContent: true } })
      .subscribe((resp) => {
        if (resp['status']) {
          this.isLoadingData = false;
          this.applyJobForm.reset();
          this.modalService.dismissAll()
          this.toaster.Success(resp.message);
        }
        else {
          this.toaster.Error(resp.message);
          this.isLoadingData = false;
        }
      });
  }

}
